export default __webpack_public_path__ + "static/media/showcase-disabilities.657614ab.jpg";